var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Tạo vận đơn"}},[_c('lading-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }